var map = {
	"./a-global-data-consensus": 217,
	"./a-global-data-consensus.json": 217,
	"./balancing-data-protection-and-competition": 218,
	"./balancing-data-protection-and-competition.json": 218,
	"./citizen-science-protects-fishing-in-amazon": 219,
	"./citizen-science-protects-fishing-in-amazon.json": 219,
	"./community-led-data-collection-in-rural-india": 220,
	"./community-led-data-collection-in-rural-india.json": 220,
	"./covid-19-increased-data-consumption": 221,
	"./covid-19-increased-data-consumption.json": 221,
	"./covid-19-the-social-contract-in-action": 222,
	"./covid-19-the-social-contract-in-action.json": 222,
	"./developing-data-to-end-violence-against-women-and-girls": 223,
	"./developing-data-to-end-violence-against-women-and-girls.json": 223,
	"./environment-datas-carbon-footprint": 224,
	"./environment-datas-carbon-footprint.json": 224,
	"./governance-international-cooperation": 225,
	"./governance-international-cooperation.json": 225,
	"./home": 185,
	"./home.json": 185,
	"./repurposing-data-to-make-roads-safer": 226,
	"./repurposing-data-to-make-roads-safer.json": 226,
	"./the-potential-of-open-data-to-help-businesses": 227,
	"./the-potential-of-open-data-to-help-businesses.json": 227,
	"./the-role-of-international-organizations-in-improving-public-intent-data": 228,
	"./the-role-of-international-organizations-in-improving-public-intent-data.json": 228,
	"./using-data-to-manage-debt-during-the-COVID-19-pandemic": 229,
	"./using-data-to-manage-debt-during-the-COVID-19-pandemic.json": 229,
	"./weather-data-valuable-for-development": 230,
	"./weather-data-valuable-for-development.json": 230,
	"./who-owns-personal-data": 231,
	"./who-owns-personal-data.json": 231
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 453;